var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.28,
    height: 15.552,
    viewBox: "0 0 17.28 15.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.765,
    cy: 2.765,
    r: 2.765,
    transform: "translate(5.875 5.875)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.048,25.5,4.493,27.228H1.728A1.733,1.733,0,0,0,0,28.956V39.324a1.733,1.733,0,0,0,1.728,1.728H15.552a1.733,1.733,0,0,0,1.728-1.728V28.956a1.733,1.733,0,0,0-1.728-1.728H12.787L11.232,25.5ZM8.64,38.46a4.32,4.32,0,1,1,4.32-4.32A4.278,4.278,0,0,1,8.64,38.46Z",
    transform: "translate(0 -25.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bcadc533.svg";
export { ForwardRef as ReactComponent };